import { ReactNode } from 'react'

import CommonLayout from '@/components/layouts/common/Layout'
import Navbar from '@/components/layouts/opportunity/Navbar'
import { BreadcrumbProvider } from '@/components/opportunity/common/BreadcrumbV2/context'

import { AwardExistenceLoaderProvider } from '@/services/award-existence-loader/context'

interface LayoutProps {
  children: ReactNode
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <BreadcrumbProvider>
      <AwardExistenceLoaderProvider>
        <CommonLayout
          navbar={Navbar}
          innerClassName="bg-primary-50 dark:bg-default-dark"
        >
          {children}
        </CommonLayout>
      </AwardExistenceLoaderProvider>
    </BreadcrumbProvider>
  )
}

export const getLayout = (page: ReactNode) => <Layout>{page}</Layout>

export default Layout
